
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const bax2020Beast: IProductData = {
  id: "popeaudio-bax2020-beast",
  name: "BAX 2020 Beast",
  description: "Baxendall style EQ and drive with Character.",
  specialOrder: true,
  images: ["/img/bax_beast.jpg", "/img/bax_stripes.jpg"],
  details: [{
    label: "Description",
    markdown: `
Pope Audio BAX 2020 'Beast' combines analog 'Hi' & 'Lo' frequency gain control, in a compact, fuss-free module.  
This version utilizes an Avedis 1122 on the input, giving the user a chance to "drive" the input stage to get the desired level of "flavor" from the DAO (Discrete Op Amp).  
Plus it has another 1122 driving into a transformer on the output.  
When not required in the signal path, the unit is in hard bypass, meaning that the signal is left 100% unaffected by the unit. 

The BEAST features an Avedis 1122 input discrete op-amp and a second 1122 driving into a transformer on the output.  
`
  }, {
    label: "Features",
    markdown: `
- Avedis 1122 input DOA (discrete op-amp)
- Avedis 1122 output DOA
- EA2623 Custom-made output Transformer
- True Bypass
- Hand-built in U.K.
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.popeaudio.co.uk/general-1-1-1" target="_blank">https://www.popeaudio.co.uk/general-1-1-1</a>
    `
  }],
  videos: ["https://www.youtube.com/embed/o94YQa2Nr_A?si=PgBYFdlCXY0CO-Mv", "https://www.youtube.com/embed/XUL-radnNJ4?si=LkFANPcfjJJYbsyL"],
  metadata: {
    hashtags: [HASHTAGS.EQ, HASHTAGS.MIXING, HASHTAGS.RECORDING, HASHTAGS.SINGLE_SLOT, HASHTAGS.API_500, HASHTAGS.MASTERING],
    manufacturer: BRAND.POPE_AUDIO,
  }
}